import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { RouterModule } from '@angular/router'
import { SeFeButtonModule } from 'se-fe-button'
import { SeFeCardModule } from 'se-fe-card'
import { SeFeDocsExampleModule } from 'se-fe-docs-example'
import { SeFeDocsTableModule } from 'se-fe-docs-table'
import { SeFeHeaderModule } from 'se-fe-header'
import { SeFePageModule } from 'se-fe-page'
import { SeFeToastModule } from 'se-fe-toast'
import { SharedUiGuardianInviteInfoModule } from '../lib/shared-ui-guardian-invite-info.module'
import { GuardianInviteInfoDocsComponent } from './guardian-invite-info-docs/guardian-invite-info-docs.component'
import { GuardianInviteInfoExampleComponent } from './guardian-invite-info-docs/guardian-invite-info-example.component'

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    SeFeButtonModule,
    SeFeCardModule,
    SeFeDocsExampleModule,
    SeFeDocsTableModule,
    SeFeHeaderModule,
    SeFePageModule,
    SeFeToastModule,
    SharedUiGuardianInviteInfoModule
  ],
  declarations: [
    GuardianInviteInfoDocsComponent,
    GuardianInviteInfoExampleComponent
  ],
  exports: [
    GuardianInviteInfoDocsComponent
  ]
})
export class SharedUiGuardianInviteInfoDocsModule {}
